export default () => ({
  root: {
    position: 'fixed',
    bottom: 0,
    alignItems: 'right',
  },
});
